<template>
  <div id="task-timer" class="task-timer panel list-panel">
    <el-card class="box-card">
      <div slot="header" class="timer-header">
        <!-- NO LOG RUNNING - NOT ON TASK PAGE (probs on dashboard) -->
        <div class="timer-title" v-if="task && !runningLog && !showSpinnerButton && !taskClosed">
          <b>Want to start the timer?</b><br>
          Just press play!
        </div>
        <!-- TIMER STARTING -->
        <div class="timer-title"  v-if="!runningLog && showSpinnerButton">
          <b>Starting Timer</b><br>
          Please wait..
        </div>
        <!-- NO LOG RUNNING - ON TASK PAGE -->
        <div class="timer-title"  v-if="!task && !runningLog && !showSpinnerButton">
          <b>No Timer Started.</b>
        </div>

        <div class="timer-title"  v-if="activeLogOnOtherTask && !taskClosed">
          <b>You are currently working on {{ runningLog.project_code }} - {{ runningLog.task_title }}</b><br>
          Stop your active timer to begin working on {{ task.project_code }} - {{ task.title }}
        </div>

        <div class="timer-title" v-if="taskClosed">
          <b>{{ task.project_code }} - {{ task.project_name }} has been Closed.</b><br>
          You cannot log time against it.
        </div>

        <div class="timer-task" v-if="runningLog && !activeLogOnOtherTask">
          <client-code v-if="!runningLog.client_icon_url" :code="runningLog.client_code" :seed="runningLog.client_name"/>
          <img v-if="runningLog.client_icon_url" :src="runningLog.client_icon_url" class="client-code"/>
          <div class="info">
            <b>{{ runningLog.client_name }} - {{ runningLog.project_code }}</b><br>
            <span>{{ runningLog.project_name }} - </span>{{ runningLog.task_title }}
          </div>
        </div>

        <!----- TIMER BUTTONS ----->
        <!-- START TIME BUTTON -->
        <el-button type="success"
                   size="mini"
                   :round="true"
                   class="timer-btn pull-right"
                   v-if="showStartButton"
                   :disabled="!task || activeLogOnOtherTask || taskClosed"
                   @click="startTimer"
                   v-shortkey.once="['ctrl', 'enter']"
                   @shortkey.native="startTimer">
          <icon name="play" />
        </el-button>

        <!-- TIMER STARTING FAKE BUTTON -->
        <el-button type="warning"
                   size="mini"
                   :round="true"
                   v-if="showSpinnerButton"
                   class="timer-btn loading pull-right">
          <icon name="circle-notch" spin />
        </el-button>

        <!-- TIMER STOP BUTTON -->
        <el-button type="danger"
                   size="mini"
                   :round="true"
                   class="timer-btn"
                   v-if="showStopButton"
                   @click="stopTimer">
          <icon name="stop" />
        </el-button>
      </div>


      <!-- TIMER BODY -->
      <div class="timer-body list-group">
        <div class="timer-info">
          <el-select class="tag-select"
                     v-model="logTagId"
                     v-if="taskProjectTags.length"
                     :disabled="disableLogBody"
                     clearable
                     placeholder="Project Component">
            <el-option
                v-for="item in taskProjectTags"
                :key="item.id"
                :label="item.tag"
                :value="item.id">
            </el-option>
          </el-select>

          <el-input
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 10}"
            placeholder="Comment.."
            :disabled="disableLogBody"
            v-model="logComment"
            v-shortkey.once="['ctrl', 'enter']"
            @shortkey.native="addLogAndRestartTimer"
          >
          </el-input>
          <transition name="fade">
            <span class="save-hint" v-if="runningLog && logComment">Hint: use Ctrl + Enter to add Log</span>
            <span class="start-hint" v-if="task && !runningLog && !showSpinnerButton">Hint: use Ctrl + Enter to start</span>
          </transition>
        </div>
        <div class="timer-actions">
          <div class="timer"
               :class="{ 'active-task': !disableLogBody }">
            <icon name="regular/clock" />
            <span class="total-time" v-if="disableLogBody">{{ secondsToTime(0) }}</span>
            <span class="total-time" v-if="!disableLogBody">{{ secondsToTime(runningLogTime) }}</span>
          </div>
          <el-button type="info"
                     @click="addLogAndRestartTimer"
                     :disabled="disableLogBody"
                     title="Adds a Log at this point in time and then immediately restarts the timer"
                     size="small">ADD LOG</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mixin as LogTimes } from '../../mixins/LogTimes'
  import { mixin as Utils } from '../../mixins/Utils'
  export default {
    name: 'task-timer',
    mixins: [LogTimes, Utils],
    props: {
      title: {
        default: 'Timer'
      },
      task: null
    },
    data () {
      return {
        runningLogFound: false,
        runningLogTime: '',
        updateRunningLogTimeInterval: null,
        dialogOpen: false,
        logComment: '',
        logTagId: null,
        restartLogWithTaskId: false // Set to the task_id of the next log when pressing 'Add Log'
      }
    },
    methods: {
      startTimer () {
        if (this.task && !this.runningLog && !this.activeLogOnOtherTask && !this.taskClosed) {
          // Omitting 'start' will tell the API to set the start to the current datetime
          var object = {
            'user_id': this.$store.state.users.currentUser.id,
            'task_id': this.task.id
          }
          this.$store.dispatch('createLog', object)
        }
      },
      stopTimer () {
        // We need to explicitly tell the API to stop the log
        this.runningLog.comment = this.logComment
        this.runningLog.tag_id = this.logTagId
        this.runningLog.action = 'stop'
        this.$store.dispatch('updateLog', this.runningLog)
        this.$store.dispatch('setInEditLogComment', '') // Make sure we clear the saved log comment
        this.logComment = ''
        this.logTagId = null
      },
      addLogAndRestartTimer () {
        if (this.runningLog) {
          // Stop the running log and submit it, then immediately start a new Log for the same task
          this.restartLogWithTaskId = this.runningLog.task_id // SEE 'updateLogInProgress' WATCHER FOR RESTART FUNC.
          this.stopTimer()
        }
      },
      updateRunningLogTime () {
        if (this.runningLog) {
          this.runningLogTime = this.logAsTime(this.runningLog)
        }
      },
      gotoTask (taskId) {
        this.$router.push({name: 'task', params: { task_id: taskId }})
      }
    },

    computed: {
      runningLogTask () {
        // Used to find the task relating to the log even when the task prop has not been passed
        if (this.task) {
          return this.task
        } else if (this.runningLog && this.tasks[this.runningLog.task_id]) {
          return this.tasks[this.runningLog.task_id]
        } else {
          return null
        }
      },
      runningLogProject () {
        if (this.runningLogTask) {
          return this.projects[this.runningLogTask.project_id]
        }
        return null
      },
      taskProject () {
        if (this.task && this.projects[this.task.project_id]) {
          return this.projects[this.task.project_id]
        } else {
          return null
        }
      },
      taskProjectTags () {
        if (this.runningLogProject) {
          return this.runningLogProject.tags
        }
        return []
      },
      createLogInProgress () {
        return this.$store.state.logs.createInProgress
      },
      updateLogInProgress () {
        return this.$store.state.logs.updateInProgress
      },

      disableLogBody () {
        // Should the Log Entry Controls be disabled?
        return (!this.runningLog || this.restartLogWithTaskId !== false || this.activeLogOnOtherTask)
      },

      activeLogOnOtherTask () {
        // Are we viewing a task but have a timer active for a different task?
        return (this.task && this.runningLog && this.task.id !== this.runningLog.task_id)
      },

      taskClosed () {
        // Is the task closed and timer inaccessible?
        return (this.taskProject && !this.taskProject.status)
      },

      // Action buttons show/hide bindings
      showStartButton () {
        // The start button should only be shown if there is a current task, and there are no other button states active
        // e.g. a log in progress or a log updating
        return (!this.showSpinnerButton && !this.showStopButton)
      },

      showSpinnerButton () {
        // The spinner is shown as an intermediary between the start and stop states
        return (this.createLogInProgress || // A log is currently being created
          (this.updateLogInProgress && this.runningLog && // A log is being updated,
            this.updateLogInProgress.id === this.runningLog.id)) // and it is specifically the running log (other components update logs too)
      },

      showStopButton () {
        // Stop button should only be shown if there is a running log that is not in the update process,
        // and the current running log belongs to the current task (passed down through props)
        return (!this.showSpinnerButton &&
                this.runningLog && this.runningLogTask &&
                this.runningLog.task_id === this.runningLogTask.id)
      },

      // Vuex mappings
      currentUser () {
        return this.$store.state.users.currentUser
      },
      runningLog () {
        return this.$store.getters.runningLog
      },
      clients () {
        return this.$store.state.clients.objects
      },
      projects () {
        return this.$store.state.projects.objects
      },
      tasks () {
        return this.$store.state.tasks.objects
      },
      tags () {
        return this.$store.state.tags.objects
      }
    },

    watch: {
      logComment () {
        // We want to cache the comment so the user can come back to it later..
        this.$store.dispatch('setInEditLogComment', this.logComment)
      },
      'runningLog' () {
        this.updateRunningLogTime()
        if (!this.task && this.runningLog) {
          if (!this.runningLogFound) {
            this.runningLogFound = true
            // Get the task related to the running log when it hasnt been passed via props
            this.$store.dispatch('getTask', this.runningLog.task_id)
          }
        } else {
          this.runningLogFound = false
        }
      },
      'updateLogInProgress' () {
        if (!this.updateLogInProgress && this.restartLogWithTaskId !== false) {
          // Log update completed but we need to restart it..
          // Omitting 'start' will tell the API to set the start to the current datetime
          const object = {
            'user_id': this.$store.state.users.currentUser.id,
            'task_id': this.restartLogWithTaskId
          }
          this.$store.dispatch('createLog', object)
          this.restartLogWithTaskId = false // Clear the resart flag
        }
      }
    },
    mounted () {
      setTimeout(() => {
        this.updateRunningLogTimeInterval = setInterval(this.updateRunningLogTime, 1000)
      })

      // We are viewing the currently active log. Show the cached log comment
      if (this.showStopButton) {
        this.logComment = this.$store.state.logs.inEditLogComment
      }

    },
    beforeDestroy () {
      clearInterval(this.updateRunningLogTimeInterval)
    }
  }
</script>
<style lang="less" rel="stylesheet/less">
  #task-timer {
    padding-bottom: 0;
  }
  .task-timer {
    .timer-header {
      display: flex;
      position: relative;
      align-items: center;
      .timer-title {
        flex: 1;
        font-size: 1.1rem;
      }
      .timer-task {
        flex: 1;
        display: flex;
        align-items: center;
      }
    }
    .timer-body {
      padding: 15px 20px !important;
      display: flex;
      position: relative;
      .tag-select {
        margin-bottom: 10px;
      }
      .timer-info {
        flex: 1;
        margin-right: 15px;
      }
      textarea {
        border-radius: 10px;
        resize: none;
        font-size: 16px;
      }
      .timer {
        margin-top: 5px;
        margin-bottom: 15px;
        color: #AAA;
      }
    }
    .timer-btn {
      width: 42px;
      height: 42px;
      border-radius: 22px;
      .fa-icon {
        vertical-align: middle;
      }

      &.closed {
        margin-top: 12px;
      }

      &.el-button--success {
        box-shadow: 2px 2px 5px fade(#67c23a, 40%);
        &.is-disabled {
          box-shadow: 2px 2px 5px fade(#b3e19d, 40%);
        }
      }
      &.el-button--warning {
        box-shadow: 2px 2px 5px fade(#e6a23c, 40%);
      }
      &.el-button--danger {
        box-shadow: 2px 2px 5px fade(#f56c6c, 40%);
      }
    }

    .el-card__header {
      margin: 0 !important;
      background-color: #FFF;
    }
    .el-card__body {
      .el-tag {
        margin-top: 4px;
      }
    }

    .task-link {
      cursor: pointer;
    }
    .loading {
      padding: 0;
    }
    .fa-icon {
      max-width: 100%;
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .start-hint,
  .save-hint {
    color: #666;
    font-size: 0.6rem;
    line-height: 1rem;
    margin: 0;
    left: 30px;
    position: absolute;
    bottom: 0;
  }

</style>
